import { Progress } from 'radix-ui';
import styles from './styles.module.scss';
import { Icon } from '../Icon';
import { HelperTooltip } from '../components/HelperTooltip';
import { useTranslation } from 'react-i18next';

export interface TimedEventItemProps {
  iconId?: string;
  categoryId: string;
  eventId: string;
  current: number;
  max: number;
  paused: boolean;
}

export const TimedEventItem = ({ iconId, categoryId, eventId, current, max, paused }: TimedEventItemProps) => {
  const currentValue = Math.min(Math.max(0, current), max);
  const progress = Math.min((currentValue / max) * 100, 100);

  const { t } = useTranslation('tooltip', { keyPrefix: 'events' });

  return (
    <HelperTooltip
      content={<div className={styles.tooltipDescription}>{t(eventId)}</div>}
      contentClassName={styles.tooltipContent}
    >
      <div className={`${styles.timedEventItem} ${paused ? styles.paused : ''}`}>
        <Icon iconId={iconId || categoryId} />
        <Progress.Root className={styles.progressBar} value={currentValue} max={max}>
          <Progress.Indicator
            className={styles.progressBarValue}
            style={{
              width: `${progress}%`,
            }}
          />
        </Progress.Root>
      </div>
    </HelperTooltip>
  );
};
